import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';

export default class PortalToastrContainer extends Component {

  render(){

    return (
        <ToastContainer
          className='cx-toastr' 
          bodyClassName='cx-toastr-body' 
          toastClassName='cx-toastr-container' 
          progressClassName='cx-toastr-progress-bar' />
    );
  }
}